import {createSlice} from "@reduxjs/toolkit";

const paginationTemplate = {
  loading: false,
  error: '',
  data: [],
  meta: {},
  init: false,

  hasNext: true,
  page: 0,
  totalResults: 0
};
const normalTemplate = {
  loading: false,
  error: '',
  data: {},
  init: false
};
const initialState = {
  focused: {

    template: {
      ...normalTemplate
    }
  },
  brandDay: {

    template: {
      ...normalTemplate
    }
  },
  brandMonth: {

    template: {
      ...paginationTemplate
    }
  },
  products: {

    template: {
      ...paginationTemplate
    }
  },
  productCampaign: {
    template: {
      ...paginationTemplate,
    }
  },
  dynamicBanner: {
    template: {
      ...normalTemplate,
    }
  },
  prediction: {
    template: {
      ...normalTemplate,
    }
  }
};

const dynamicMultipleElementsSlice = createSlice({
  name: 'dynamicMultipleElements',
  initialState: initialState,
  reducers: {

    setLoading: (state, action) => {
      if (!state[action.payload.element][action.payload.id]) {
        state[action.payload.element][action.payload.id] = {...initialState[action.payload.element].template};
      }

      state[action.payload.element][action.payload.id].error = '';
      state[action.payload.element][action.payload.id].loading = action.payload.loading;
    },
    setResult: (state, action) => {
      if (state[action.payload.element][action.payload.id] === undefined) {
        return;
      }
      state[action.payload.element][action.payload.id].error = action.payload.error ?? "";
      state[action.payload.element][action.payload.id].loading = false;
      if (!action.payload.error) {
        state[action.payload.element][action.payload.id].init = true;

        if (action.payload.meta) {
          state[action.payload.element][action.payload.id].meta = action.payload.meta;
        }

        if (action.payload.hasNext !== undefined) {
          state[action.payload.element][action.payload.id].hasNext = action.payload.hasNext;
          state[action.payload.element][action.payload.id].totalResults = action.payload.totalResults;
          state[action.payload.element][action.payload.id].page = action.payload.page;
          state[action.payload.element][action.payload.id].data =
            [...state[action.payload.element][action.payload.id].data, ...action.payload.data];
        } else {
          state[action.payload.element][action.payload.id].data = action.payload.data;
        }
      }


    },
    setMetaResult: (state, action) => {
      if (state[action.payload.element][action.payload.id] === undefined) {
        return;
      }
      state[action.payload.element][action.payload.id].meta = action.payload.data;
    },
    reset: (state, action) => {
      if (state[action.payload.element][action.payload.id] === undefined) {
        return;
      }
      state[action.payload.element][action.payload.id] = {...initialState[action.payload.element]["template"]};
    },

    resetAll: (state, action) => initialState,
    loadFocusedItem() {
    },
    loadBrandDayInfo() {
    },
    loadBrandMonthList() {
    },
    loadHotSpecialList() {
    },
    loadProductListByValueAndType() {
    },
    loadFreshSpecialList() {
    },
    loadFlashSaleList() {
    },
    loadDynamicBanner(){
    },
    loadNothing(){
    },
    loadFeaturedList(){},
    loadPrediction(){}
  }
});


export const {
  setLoading,
  setResult,
  reset,
  loadFocusedItem,
  loadBrandDayInfo,
  setMetaResult,
  loadBrandMonthList,
  loadHotSpecialList,
  loadFreshSpecialList,
  loadFlashSaleList,
  resetAll,
  loadProductListByValueAndType,
  loadNothing,
  loadDynamicBanner,
  loadFeaturedList,
  loadPrediction
} = dynamicMultipleElementsSlice.actions;

export default dynamicMultipleElementsSlice.reducer;
